//import PerlinNoise from '@/utils/perlin.js'
import SimplexNoise from 'simplex-noise'
import paper from 'paper'

const simplex = new SimplexNoise()

// helper functions
const N = 100
//const P = (x, y) => P(Noise(N * x, N * y, 0.9)
const P = (x, y) => PerlinNoise(N * x, N * y, 0.9)
const R = (m) => Math.round(Math.random()*m)

// random direction
const RD = (r) => {
  let a = Math.random(), b = Math.random()

  if (b < a) {
    [a, b] = [b, a]
  }

  return new Point(b*r*Math.cos(2*Math.PI*a/b), b*r*Math.sin(2*Math.PI*a/b))
}

const rndStrokeWidth = {
  valueOf: () => 0.2+Math.random()*1.5
}

const rndColor = {
  toString: () => {
    //let a = ['#9b0000', '#ccc', '#999']
    let a = ['#9b0000', '#2b00000', '#cc0000']
    let c = new Color(a[R(0)])
    //c.hue = 20+R(10)
    c.saturation = R()
    return c.toCSS()
  }
}
// end helpers

/*
G = Glyph     G = GlyphLine     GGG = GlyphBlock
              G                 GGG
              G                 GGG
*/

class Glyph {
	constructor(strokeWidth, strokeColor) {
		this.path = new Path({strokeWidth, strokeColor})
  }

  draw(point, sz) {
    //let sz = Math.abs(point.x, point.y)
    this.path.add(point)
    this.path.cubicCurveTo(
      point.add(RD(sz)),
      point.add(RD(sz)),
      point.add(RD(sz)))

    return this.path
  }
}

class GlyphLine {
  constructor(start, strokeColor, strokeWidth) {
    this.start = start
    this.strokeColor = strokeColor
    this.strokeWidth = strokeWidth
    this.glyphs = []
  }

  draw(num, sz, dir) {
    let p = this.start

    for (let x = 0; x < num; x++) {
      let strokeWidth = this.strokeWidth || 0.2+Math.random()
      let strokeColor = new Color(''+(this.strokeColor || '#fff'))
      strokeColor.alpha = Math.abs(simplex.noise2D(x, x))//*0.5 + 0.5
      let g = new Glyph(strokeWidth, strokeColor)
      let path = g.draw(p, sz)

      this.glyphs.push(g)

      // move to next
      let pointAdd = (dir == 'vertical') ? new Point(0, 0.6*sz) : new Point(0.6*sz, 0)
      p = p.add(pointAdd)
    }
  }
}
class GlyphBlock {
  constructor(start, strokeColor, strokeWidth) {
    this.start = start
    this.strokeColor = strokeColor || '#fff'
    this.strokeWidth = strokeWidth || 0.5
    this.lines = []
  }

  draw(sz, numx, numy) {
    let p = this.start

    numx = numx || (10+R(10))
    for (let n = 1; n < numx; n++) {
      let gl = new GlyphLine(p, this.strokeColor, this.strokeWidth)

      let _numy = numy || (10+R(20))

      gl.draw(_numy, sz, 'vertical')

      this.lines.push(gl)
      // move to next
      p = p.add(new Point(sz, 0))
    }
  }
}

// main function
export default function(canvas) {
  // init
  paper.install(window)
	paper.setup(canvas)

  function drawBlocks() {
    let p, block

    let blocks = []

    let sz = 32,
        numx = (canvas.width / (sz*2))-1,
        numy = ((canvas.height / sz))

    // fill the canvas with deeewdlz
    // sz = 2300x1000
    // 50,50 50,180, 250,50
    // XXX: spacing
    let b = {
      x: 50, y: 0, sz: sz,
      numx:  (canvas.width / (sz))-1,
      numy:  (canvas.height)-10,
      color: '#888888'
    }

    let bs = [b]
    let _b = {...b}

    _b.color = '#666666'
    bs.push(_b)

    // erazor * 2
    _b = {...b}
    _b.sz *= 2
    _b.numx /= 2
    _b.numy /= 2
    _b.color = '#fff'//'#140000'
    _b.width = rndStrokeWidth*10
    bs.push(_b)

    _b = {..._b}
    //_b.sz *= 2
    _b.width = rndStrokeWidth*20
    bs.push(_b)

    for (let b of bs) {
      //console.log(b)
      p = new Point(b.x, b.y)
      block = new GlyphBlock(p, b.color, b.width || rndStrokeWidth)
      block.draw(b.sz, b.numx, b.numy)
      blocks.push(block)
    }

    return blocks
  }

  function drawText() {
    var text = new PointText(new Point(200, 50))
    text.fontFamily = 'monospace'
    text.fillColor = '#292929'
    text.fontSize = '21px'
    text.content = 'c2hc2hC222222H'
  }

  let blocks = drawBlocks()
  //drawText()

  let tool = new Tool()
  tool.onMouseDown = (e) => {
    paper.project.activeLayer.removeChildren()
    blocks = drawBlocks()
    //drawText()
  }

  /*
  //view.onFrame = (e) => {
  tool.onMouseMove = (e) => {
    //let x = e.time, y = e.count // delta
    let x = e.event.clientX, y = e.event.clientY
    //if (e.count % 90) return
    for (let block of blocks) {
      for (let line of block.lines) {
        for (let glyph of line.glyphs) {
          let path = glyph.path
          path.strokeColor.alpha = 0.8+P(x, y)
        }
      }
    }
  }
  */
}
